import instance from "../../utils/axios";

export const saveYoutubePlan = async (payload) => {
  const params = new URLSearchParams();
  params.append("youtubelink", payload.youtubelink);
  params.append("planName", payload.planName);
  params.append("planThumbnailUrl", payload.planThumbnailUrl);

  if (payload.churchObjId) params.append("churchObjId", payload.churchObjId);
  if (payload.channelObjId) params.append("channelObjId", payload.channelObjId);
  if (payload.ministriesObjId) params.append("ministriesObjId", payload.ministriesObjId);
  if (payload.scope) params.append("scope", payload.scope);
  if (payload.typeofentity) params.append("typeofentity", payload.typeofentity);
  if (payload.entityObjId) params.append("entityObjId", payload.entityObjId);
  if (payload.fcmToken) params.append("fcmToken", payload.fcmToken);

  const res = await instance.post("/youtubeplans", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return res.data;
};

export const fetchUserJobs = async (payload) => {
  const params = new URLSearchParams();
  if (payload?._id) params.append("_id", payload._id);
  if (payload?.page) params.append("page", payload.page);
  if (payload?.limit) params.append("limit", payload.limit);

  const res = await instance.post("/sermon-studies/userjobs", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return res.data;
};

export const fetchCmsSermonStudies = async (payload = {}) => {
  const res = await instance.post("/sermon-studies/cms/read", payload);
  return res.data;
};

export const fetchGlobalSermonStudies = async (payload = {}) => {
  const res = await instance.post("/sermon-studies/global/read", payload);
  return res.data;
};

export const attachGlobalSermonStudy = async (payload = {}) => {
  const res = await instance.post("/sermon-studies/global/attach", payload);
  return res.data;
};

export const detachGlobalSermonStudy = async (payload = {}) => {
  const res = await instance.post("/sermon-studies/global/detach", payload);
  return res.data;
};
